import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu\"><path d=\"M0 0h455.111111v455.111111H0V0z m0 568.888889h455.111111v455.111111H0v-455.111111zM568.888889 0h455.111111v455.111111h-455.111111V0z m0 568.888889h455.111111v455.111111h-455.111111v-455.111111z\" p-id=\"4327\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol